import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { rhm, dt, titleCase } from "../api";
import { Badge, Card, Empty, Input, PageHead, Select, Table, Td } from "../ui";

const MODULES = ["", "products", "inventory", "batches", "purchases", "suppliers", "users", "roles", "settings", "orders"];

export default function RhmAudit() {
    const [module, setModule] = useState("");
    const [q, setQ] = useState("");

    const { data: rows = [], isLoading } = useQuery({
        queryKey: ["rhm-audit", module, q],
        queryFn: async () => (await rhm.get("/audit", { params: { module: module || undefined, q: q || undefined } })).data,
    });

    return (
        <div data-testid="rhm-audit-page">
            <PageHead title="Audit Log" sub="Every sensitive change is recorded with the user, timestamp and before/after values." />
            <Card
                title={`${rows.length} entries`}
                action={
                    <div className="flex gap-3">
                        <Select value={module} onChange={(e) => setModule(e.target.value)} className="!w-40" data-testid="audit-module-filter">
                            {MODULES.map((m) => <option key={m} value={m}>{m ? titleCase(m) : "All modules"}</option>)}
                        </Select>
                        <Input placeholder="Search" value={q} onChange={(e) => setQ(e.target.value)} className="!w-48" data-testid="audit-search" />
                    </div>
                }
            >
                {isLoading ? <div className="mono text-xs text-zinc-500">LOADING…</div> : (
                    <Table testId="rhm-audit-table" head={["When", "User", "Module", "Action", "Record", "Before", "After"]}
                        empty={!rows.length && <Empty msg="No audit entries." />}>
                        {rows.map((a) => (
                            <tr key={a.id}>
                                <Td className="text-xs text-zinc-500 whitespace-nowrap">{dt(a.created_at)}</Td>
                                <Td className="text-sm">{a.user_name}</Td>
                                <Td><Badge>{titleCase(a.module || "")}</Badge></Td>
                                <Td className="text-sm text-gold">{titleCase(a.action)}</Td>
                                <Td className="text-sm text-zinc-300">{a.record_label || a.record_type}</Td>
                                <Td className="text-xs text-zinc-500 max-w-[200px] truncate">{a.before ? JSON.stringify(a.before) : "—"}</Td>
                                <Td className="text-xs text-zinc-400 max-w-[200px] truncate">{a.after ? JSON.stringify(a.after) : "—"}</Td>
                            </tr>
                        ))}
                    </Table>
                )}
            </Card>
        </div>
    );
}
